import { gql } from 'graphql.macro';

export const UpdateUserDepot = gql`
  mutation UpdateObservationDepotManagerDepots($request: DepotManagerUpdateRequestModelInput!) {
    updateObservationDepotManagerDepots(request: $request)
  }
`;